import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Container from 'common/Container';
import { useTheme } from '@material-ui/core/styles';
import AutoAwesomeIcon from '@material-ui/icons/AutoAwesome';

const Hero = ({ themeMode = 'light' }) => {
  const theme = useTheme();

  return (
    <Box>
      <Box marginBottom={2}>
        <Container
          sx={{
            backgroundImage:
              themeMode === 'dark'
                ? 'url(/images/logos/logo_white.PNG)'
                : 'url(/images/logos/logo_tnonetwork_black.png)',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundSize: 'contain',
            height: '16vh',
          }}
        />
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 600 }}
          variant="overline"
          color="textSecondary"
          align="center"
          display="block"
          gutterBottom
        >
          Propuesta de alianza
        </Typography>
        <Box
          component={Typography}
          fontWeight={700}
          variant="h3"
          gutterBottom
          align="center"
          color={theme.palette.primary.main}
        >
          Nexus Cultural × Punto de Fe
        </Box>
        <Typography
          variant="h5"
          component="p"
          color="textSecondary"
          align="center"
          sx={{ fontWeight: 600, mb: 1 }}
        >
          Cultura para el Alma
        </Typography>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 1,
            mb: 2,
          }}
        >
          <AutoAwesomeIcon color="primary" fontSize="small" />
          <Typography
            variant="subtitle1"
            align="center"
            color="primary"
            sx={{ fontStyle: 'italic', maxWidth: 520 }}
          >
            Donde el arte y la espiritualidad se encuentran para sanar.
          </Typography>
          <AutoAwesomeIcon color="primary" fontSize="small" />
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            mb: 3,
          }}
        >
          <Box
            component="img"
            src="/images/nexus.webp"
            alt="Nexus Cultural"
            sx={{
              width: 160,
              height: 160,
              objectFit: 'contain',
            }}
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
        </Box>
        <Box
          sx={{
            maxWidth: 720,
            mx: 'auto',
            py: 2,
            px: 2,
            borderRadius: 2,
            bgcolor: theme.palette.mode === 'dark' ? 'action.hover' : 'grey.50',
          }}
        >
          <Typography
            variant="h6"
            component="p"
            color="textSecondary"
            align="center"
            gutterBottom
          >
            <strong>El eje estratégico</strong>
          </Typography>
          <Typography variant="body1" color="textSecondary" align="center">
            <strong>Nexus Cultural</strong> no será solo un patrocinante: se convierte en el{' '}
            <strong>aliado de contenido cultural y espiritual</strong> del programa. El objetivo es
            fusionar la sanación angelical y el bienestar con la promoción de espacios y eventos que
            eleven la conciencia del espectador.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

Hero.propTypes = {
  themeMode: PropTypes.string,
};

export default Hero;
